import React from "react";
import payment from "../../assets/M-pesa_logo.jpg";
// import payment from "../../assets/payment.svg";
function Copyright() {
  return (
    <div className="container-fluid">
      <div className="footer-bottom d-flex justify-content-between">
        <span className="copyright">
          Voltharvest Technologies Pvt. Ltd. incorporated @ 2025
        </span>
        {/* <p>Developed by <a href="https://dextratechnologies.com" style={{ color: 'orange' }}>Dextratechnologies.Com</a></p> 
        */}
        <p>
          Developed by{" "}
          <a
            href="https://dextratechnologies.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'orange' , textTransform:"lowercase"}}
          >
            Dextratechnologies.Com
          </a>
        </p>

        <div className="payment">
          <img src={payment} style={{width:"90px" }} alt="payment_image" className="apple-icons" />
        </div>
      </div>
    </div>
  );
}
export default Copyright;
